export const GET_GLANCER_DASHBOARD_LIST = 'GLANCER_DASHBOARD_LIST:GET';
export const UPDATE_GLANCER_DASHBOARD_LIST = 'GLANCER_DASHBOARD_LIST:UPDATE';
export const GET_GLANCER_EMBED_URL = 'GLANCER_EMBED_URL:GET';
export const UPDATE_GLANCER_EMBED_URL = 'GLANCER_EMBED_URL:UPDATE';
